import { subMonths } from "date-fns";

export function getClosingDate() {
  let date = new Date();
  const day = date.getDate();
  
  if(day < 26) {
    date = subMonths(date, 1);
  }

  return {
    month: date.getMonth() + 1, // Months are 0-indexed in JS
    year: date.getFullYear(),
  }
}

export type ClosingDate = {
  month: number;
  year: number;
}